module.exports = ["script","style","pre","textarea"]


//////////////////
// WEBPACK FOOTER
// ../node_modules/html-whitespace-sensitive-tag-names/index.json
// module id = 1042
// module chunks = 0